import { Enumerated } from './Enumerated';

export class EVENT_STATE extends Enumerated {
  static DRAFT = 'DRAFT';
  static PUBLISHED = 'PUBLISHED';
  static CANCELLED = 'CANCELLED';
  static PENDING_PUBLISH_APPROVAL = 'PENDING_PUBLISH_APPROVAL';
}
